import React, {Fragment, useEffect, useState} from "react";
import moment from "moment";
import __ from "lodash";
import StringToJSX from "../../../../functions/StringToJsx";
import {populateComplexTemplate} from "../../../../functions/PopulateTemplate";
import { fetch as fetchComboValues } from "../../../../services/settings/useComboValues";


const prepareLines = (lines) => {
  if (lines && Array.isArray(lines)) {
    lines.forEach(line => {
      line["orderArrivalDateText"] = line.originAirportCode===line.airportCode?'':moment.utc(line.orderArrivalDate).format("DD MMM YYYY").toUpperCase();
      line["orderDepartureDateText"] = line.originAirportCode===line.airportCode?moment.utc(line.orderDepartureDate).format("DD MMM YYYY").toUpperCase():'';
      line["arrivalDateText"] = line.originAirportCode===line.airportCode?'':moment.utc(line.arrivalDate).format("DD MMM YYYY").toUpperCase();
      line["departureDateText"] = line.originAirportCode===line.airportCode?moment.utc(line.departureDate).format("DD MMM YYYY").toUpperCase():'';
      line["scheduledArrivalTimeUTC"] = line.originAirportCode===line.airportCode?'':line.scheduledArrivalTimeUTC;
      line["scheduledDepartureTimeUTC"] = line.originAirportCode===line.airportCode?line.scheduledDepartureTimeUTC:'';
      line["textDecoration"] = line.lineCancelled ? "line-through" : "";
    })
  }
  return lines;
}

const prepareServices = async (services, queryClient) => {
  const returnServices = [];
  if (services && Array.isArray(services)) {
    const rampServices = await fetchComboValues({queryClient, extraKeys: ["RAMP SERVICES", "SKELETON"], useCache: true});
    services.forEach(service=> {
      const combo = __.find(rampServices, {code: service});
      if (combo !== undefined)
        returnServices.push({requirement: combo.value});
      else
        returnServices.push({requirement: service});
    });
  }
  return returnServices;
}

const getTemplateContent = async (props) => {
  const order = props.order;
  let lines = [];
  if (Array.isArray(order.lines) && Array.isArray(order.lines[0])) {
    lines = order.lines.map(lines => prepareLines(lines));
  } else {
    lines = [prepareLines(order.lines)];
  }
  const queryClient = props.queryClient;

  const services = await prepareServices(order.requiredServices, queryClient);

  return populateComplexTemplate(order.orderTemplate, order, [...lines, services]);
}

const HandlingOrderView = (props) => {

  const [content, setContent] = useState();

  useEffect(() => {
    getTemplateContent(props).then(result => setContent(result));
  }, [props]);

  return (
    <div style={{width: "100%", maxHeight: props.maxHeight, overflowY: "scroll"}}>
      <StringToJSX domString={content}/>
    </div>
  );
}

export default HandlingOrderView;
export {getTemplateContent}